import React, { Component , useEffect } from 'react'
import { AiFillStar } from "react-icons/ai";
import { BsFillClockFill } from "react-icons/bs";
import { IoIosPeople } from "react-icons/io";
import { BsFillPersonFill } from "react-icons/bs";
import { SiGotomeeting } from "react-icons/si";
import { FaPlus } from "react-icons/fa6";
import {
  MDBCol,
  MDBRow
} from "mdb-react-ui-kit";


function CA_total_Count({ interval }) {
    // useEffect(() => {
    //   const valueDisplays = document.querySelectorAll(".num");
      
    //   valueDisplays.forEach((valueDisplay) => {
    //     const startValue = 0;
    //     const endValue = parseInt(valueDisplay.getAttribute("data-val"), 10);
    //     const duration = Math.floor(interval / endValue);
        
    //     let current = startValue;
    //     const counter = setInterval(function () {
    //       current += 1;
    //       valueDisplay.textContent = current;
    //       if (current === endValue) {
    //         clearInterval(counter);
    //       }
    //     }, duration);
  
    //     // Cleanup the interval when the component unmounts
    //     return () => clearInterval(counter);
    //   });
    // }, [interval]);
  
    return (
      <div className='mt-2 Total_count_background'>
        {/* ---------------------------Mobile View------------------------- */}
        <div className='d-sm-block py-5  d-md-none'>
        <div className='container'>
          <MDBRow className="d-flex justify-content-center">
          <MDBCol md="10" xl="8" className="text-center main_text_testmonials">
              <span className="mb-4 display-5 review_component_text fw-bold">Our Reach</span>
          </MDBCol>
          </MDBRow>
          <div className='mt-1 container-fluid'>
            <div className='row'>
            <div class="col-6">
            <div className='d-flex justify-content-evenly'>
              <div className=''><p class="mobile_num" data-val="40">10k</p></div>
              <div className=''><FaPlus  className='mobile_Total_box_icon1 mx-1' size="40px" color="black" /></div>
            </div>
            <div><p class="mobile_text">Colleges</p></div>
            </div>
            <div class="col-6">
            <div className='d-flex justify-content-evenly'>
              <div className=''><p class="mobile_num" data-val="50">50</p></div>
              <div className=''><FaPlus  className='mobile_Total_box_icon4' size="40px" color="black" /></div>
            </div>
            <div><p class="mobile_text">Mentors</p></div>
            </div>
            <div class="col-12 pt-2">
            <div className='d-flex justify-content-evenly'>
              <div className=''><p class="mobile_num_student" data-val="10000">20K</p></div>
              <div className=''><FaPlus  className='mobile_Total_box_icon3' size="40px" color="black" /></div>
            </div>
            <div><p class="mobile_text">Campus Ambassador</p></div>
            </div>
            </div>
          </div>
          </div>
        </div>

        {/* ---------------------------Dasktop View------------------------- */}
        <div className='pt-5 d-none d-md-block'>
        <div className='container'>
          <MDBRow className="d-flex justify-content-center">
          <MDBCol md="10" xl="8" className="text-center main_text_testmonials">
              <span className="mb-4 display-5 review_component_text">Our Reach</span>
          </MDBCol>
          </MDBRow>
          </div>
          <div class="wrapper pb-5 pt-3">
          <div class="box_count">
              <div className='d-flex justify-content-evenly'>
                <div className=''><p class="num" data-val="40">20K</p></div>
                <div className=''><FaPlus  className='Total_box_icon1 mx-1' size="40px" color="black" /></div>
              </div>
              <div><p class="text">Campus Am.</p></div>
          </div>
          <div class="box_count">
              <div className='d-flex justify-content-evenly'>
                <div className=''><p class="num" data-val="10000">10K</p></div>
                <div className=''><FaPlus  className='Total_box_icon3 ' size="40px" color="black" /></div>
              </div>
              <div><p class="text">Colleges</p></div>
          </div>
          <div class="box_count">
              <div className='d-flex justify-content-evenly'>
                <div className=''><p class="num" data-val="50">50</p></div>
                <div className=''><FaPlus  className='Total_box_icon4' size="40px" color="black" /></div>
              </div>
              <div><p class="text">Mentors</p></div>
          </div>
          </div>
        </div>
      </div>
    );
  }
  
  export default CA_total_Count;


